import { Injectable } from '@angular/core';
import { FuseAlertAppearance, FuseAlertType } from '@fuse/components/alert/alert.types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertState = new BehaviorSubject<{
    type: string | FuseAlertType;
    appearance: string | FuseAlertAppearance;
    message: string;
    title: string;
    visible: boolean;
    timeoutId?: any; // Para manejar el temporizador
  }>({
    type: 'success',
    appearance: 'fill',
    message: '',
    title: '',
    visible: false,
  });

  alertState$ = this.alertState.asObservable();

  showAlert(
    type: string,
    appearance: string,
    title: string,
    message: string,
    autoCloseInMs: number = 5000 // Tiempo por defecto: 5 segundos
  ): void {
    // Si ya hay un timeout activo, lo limpiamos
    if (this.alertState.value.timeoutId) {
      clearTimeout(this.alertState.value.timeoutId);
    }

    const timeoutId = setTimeout(() => {
      this.hideAlert();
    }, autoCloseInMs);

    this.alertState.next({
      type,
      appearance,
      title,
      message,
      visible: true,
      timeoutId,
    });
  }

  hideAlert(): void {
    // Limpiar cualquier temporizador activo
    if (this.alertState.value.timeoutId) {
      clearTimeout(this.alertState.value.timeoutId);
    }

    this.alertState.next({
      ...this.alertState.value,
      visible: false,
      timeoutId: null,
    });
  }
}